import React, { useState, useEffect } from 'react'
import AddProduct from '../../components/Dashboard/AddProduct/AddProduct';
import Header from '../../components/Dashboard/Header/Header'
import Navbar from '../../components/Dashboard/Navbar/Navbar'
import ErrorPage from '../ErrorPage/ErrorPage'

import { useDispatch } from 'react-redux';
import { getDashOrders } from "../../redux/features/orders/ordersSlice"

import { useAuthUser } from 'react-auth-kit';


const CreateProduct = () => {

    const auth = useAuthUser();
    document.title = 'Create Product';

    const [asideMenu, setAsideMenu] = useState(false);

    const dispatch = useDispatch();


    useEffect(() => {
        const asideMenuStorage = localStorage.getItem('sidebar');
        if (asideMenuStorage === 'closed') {
            setAsideMenu(true);
        }
        dispatch(getDashOrders());
    }, [asideMenu, dispatch]);


    if (auth().status == 'Admin' || auth().status == 'Urednik') {

        return (
            <div className='dashboard-container'>
                <Navbar asideMenu={asideMenu} setAsideMenu={setAsideMenu} />
                <div className="dashboard__main">
                    <Header asideMenu={asideMenu} setAsideMenu={setAsideMenu} />

                    <div className="main__section-nosearch ">

                        <AddProduct />

                    </div>
                </div>
            </div>
        )
    } else {
        return <ErrorPage notAdmin />
    }
}

export default CreateProduct